// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/background.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login {
  display: flex;
  align-items: center;
  justify-content: center;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center/cover no-repeat fixed;
  position: relative;
  height: 100vh;
  box-shadow: inset 0 0 0 2000px rgba(0, 0, 0, 0.3803921569);
}
.login__bgwrap {
  max-width: 28vw;
  width: 100%;
  background: #ffffff;
  border-radius: 10px;
  color: #4c85f7;
  padding: 10px;
  text-align: center;
}
.login__bgwrap__title {
  margin-top: 2rem;
  color: #7c7c7c;
  font-weight: 600;
}
.login__bgwrap__header {
  margin-top: 0.75rem;
  margin-bottom: 3rem;
}
.login__bgwrap__gradient-btn {
  background: #ea346f;
  letter-spacing: 0.05rem;
  width: 80%;
  height: 4rem;
  font-size: 18px;
  border: none;
  border-radius: 7px;
  color: #ffffff;
  font-weight: bold;
  margin-bottom: 2rem;
}

/* Media query for screens smaller than 600px wide */
/* Additional media query for screens between 600px and 1024px wide */`, "",{"version":3,"sources":["webpack://./src/components/login/login.scss","webpack://./src/scss/_variables.scss","webpack://./src/scss/_colors.scss"],"names":[],"mappings":"AAGA;ECIE,aAAA;EAGE,mBDNqB;ECUrB,uBDV6B;EAC/B,gFAAA;EAEA,kBAAA;EACA,aAAA;EACA,0DAAA;AADF;AAGE;EACE,eAAA;EACA,WAAA;EACA,mBENI;EFOJ,mBAAA;EACA,cEJM;EFKN,aAAA;EACA,kBAAA;AADJ;AAEI;EACE,gBAAA;EACA,cEhBG;EFiBH,gBAAA;AAAN;AAEI;EACE,mBAAA;EACA,mBAAA;AAAN;AAEI;EACE,mBEfM;EFgBN,uBAAA;EACA,UAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,cE5BE;EF6BF,iBAAA;EACA,mBAAA;AAAN;;AAKA,oDAAA;AAIA,qEAAA","sourcesContent":["@import \"src/scss/colors\";\n@import \"src/scss/variables\";\n\n.login {\n  @include flexContainer(center, center);\n  background: url(\"../../assets/background.webp\") center/cover\n    no-repeat fixed;\n  position: relative;\n  height: 100vh;\n  box-shadow: inset 0 0 0 2000px $blacshadow;\n\n  &__bgwrap {\n    max-width: 28vw;\n    width: 100%;\n    background: $white;\n    border-radius: 10px;\n    color: $primary;\n    padding: 10px;\n    text-align: center;\n    &__title {\n      margin-top: 2rem;\n      color: $gray7c;\n      font-weight: 600;\n    }\n    &__header {\n      margin-top: 0.75rem;\n      margin-bottom: 3rem;\n    }\n    &__gradient-btn {\n      background: $btnred_6f;\n      letter-spacing: 0.05rem;\n      width: 80%;\n      height: 4rem;\n      font-size: 18px;\n      border: none;\n      border-radius: 7px;\n      color: $white;\n      font-weight: bold;\n      margin-bottom: 2rem;\n    }\n  }\n}\n\n/* Media query for screens smaller than 600px wide */\n@media (max-width: 600px) {\n}\n\n/* Additional media query for screens between 600px and 1024px wide */\n@media (min-width: 01px) and (max-width: 1024px) {\n}\n","// mixins\n@mixin widthHeight($width, $height) {\n  width: #{$width}px;\n  height: #{$height}px;\n}\n\n@mixin flexContainer($align-items: null, $justify-content: null) {\n  display: flex;\n\n  @if $align-items != null {\n    align-items: $align-items;\n  }\n\n  @if $justify-content != null {\n    justify-content: $justify-content;\n  }\n}\n","$black: #000000;\n$blacshadow: #00000061;\n$lightblack: #f2e0bd26;\n$lightgreen: #888b8d;\n$gray_46: #464646;\n$gray7c: #7c7c7c;\n$graycc: #cccccc;\n$grayc1: #c1c1c1;\n$white: #ffffff;\n$grayf5: #f5f5f5;\n$bgwhite_f8: #f8f8f8;\n$bgwhite_f7: #f7f7f7;\n$primary: #4c85f7;\n$blue_b7: #035eb7;\n$btnred_6f: #ea346f;\n$orange65: #ffc965;\n$orangea8: #feffa8;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
